import { ChangeDetectionStrategy, Component, computed, effect, inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { OutstandingActionsCountService } from 'app/modules/actions/store/outstanding-actions-count.service';
import { outstandingActionsTooltip } from 'app/shared/utils/tab-badge.utils';
@Component({
    selector: 'outstanding-actions',
    templateUrl: './outstanding-actions.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        RouterLink
    ]
})
export class OutstandingActionsComponent {
    private readonly _outstandingActionsCountService = inject(OutstandingActionsCountService);

    readonly outstandingCount = this._outstandingActionsCountService.count;
    readonly badgeLabel = computed(() => this.outstandingCount().toString());
    readonly accessibilityLabel = computed(() => outstandingActionsTooltip(this.outstandingCount()));

    constructor() {
        effect(() => {
            this._outstandingActionsCountService.loadOutstandingActionsCount();
        });
    }
}
